import React, { PureComponent } from 'react'
import { memberService } from '../../services/MemberService'
import { switchMap } from 'rxjs/operators'
import { Subscription } from 'rxjs'
import { Row, Col, Input } from 'reactstrap'
import { AuthConsumer } from '../../auth/AuthProvider'
import { FormatCapitalizedText, FormatCapitalizedTextInObject } from '../global/TextHelpers'
import { LoadingCard } from '../cards/LoadingCard'
import $ from 'jquery'
// import ReactCrop from 'react-image-crop';
import 'react-image-crop/dist/ReactCrop.css'
import EditMemberComponent from '../forms/AddressInputField'
import SwitchUser from '../global/SwitchUser'
import { Stack } from '@mui/material'

export const DefaultProfileImage =
  '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'

export const ProfileImage = (props) => {
  if (props.profileImage) {
    // eslint-disable-next-line
    return <img className="card-img-left w-75" src={'data:image/jpeg;base64,' + props.profileImage} />
  } else {
    // eslint-disable-next-line
    return <img className="card-img-left w-75" src={'data:image/jpeg;base64,' + DefaultProfileImage} />
  }
}

export const AddressCard = (props) => {
  if (props.address) {
    if (props.isEditable) {
      return (
        <div className="profile-content pt-2 card-body bg-light extra-rounded">
          <Row className="mt-2">
            <Col sm="6" md="8">
              <Row>
                <Col sm="3" md="3">
                  <h6 className="no-h fw-7 text-primary d-inline mr-4">Address Line 1</h6>
                </Col>
                <Col sm="9" md="9"></Col>
              </Row>
            </Col>
          </Row>
        </div>
      )
    } else {
      return (
        <div className="profile-content pt-2 card-body bg-light extra-rounded">
          <span className="no-h card-profile-detail"> {props.address.address1}</span>
          {props.address.address2 && (
            <p className="no-h">
              <small className="fw-7 text-primary"> {props.address.address2}</small>
            </p>
          )}
          <span className="no-h card-profile-detail">
            {props.address.city}, {props.address.state} {props.address.zipCode}
          </span>
        </div>
      )
    }
  } else {
    return ''
  }
}

export const SubmissionNotification = (props) => {
  if (props.isSubmitting) {
    return <span className="text-info fw-7 ml-2">Submitting...</span>
  } else if (props.isSuccessful) {
    return <span className="text-success fw-7 ml-2">Submitted successfully!</span>
  } else if (props.hasFailed) {
    return <span className="text-danger fw-7 ml-2">{'Error submitting: ' + props.errorMessage}</span>
  } else if (props.clearNotification) {
    return <></>
  } else {
    return <></>
  }
  // <SubmissionNotification isSubmitting={this.state.isSubmitting} isSuccessful={this.state.isSuccessful} hasFailed={this.state.hasFailed} clearNotification={this.state.clearNotification} />
}

/*
class PhotoEdit extends React.Component {

  render() {
    return (<ReactCrop src={this.props.src} crop={this.props.crop} onChange={this.props.setCrop} circularCrop="true" />);
  }
}
*/
/**
 * @param {HTMLImageElement} image - Image File Object
 * @param {Object} crop - crop Object
 * @param {String} fileName - Name of the returned file in Promise
 */
/*
function transformToCroppedImage(image, crop, fileName) {
  //image = createImageBitmap(image);
  const canvas = document.createElement('canvas');
  const scaleX = image.naturalWidth / image.width;
  const scaleY = image.naturalHeight / image.height;
  canvas.width = crop.width;
  canvas.height = crop.height;
  const ctx = canvas.getContext('2d');

  ctx.drawImage(
    image,
    crop.x * scaleX,
    crop.y * scaleY,
    crop.width * scaleX,
    crop.height * scaleY,
    0,
    0,
    crop.width,
    crop.height,
  );

  // As Base64 string
  //return canvas.toDataURL('image/jpeg');

  // As a blob
  return new Promise((resolve, reject) => {
    canvas.toBlob(blob => {
      blob.name = fileName;
      resolve(blob);
    }, 'image/jpeg', 1);
  });
}
*/
/*
class PhotoEditModal extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      modal: false,
      crop: {
        aspect: 1,
        width: 211,
        height: 211
      }
    };
    this.srcBlob = 'data:image/jpeg;base64,' + props.src;

    this.toggle = this.toggle.bind(this);
    this.save = this.save.bind(this);
    this.setCrop = this.setCrop.bind(this);
    this.setDisabled = this.setDisabled.bind(this);
  }

  setProfileImage(src) {
    this.srcBlob = 'data:image/jpeg;base64,' + src;
  }

  setCrop(newCrop) {
    this.setState({ crop: newCrop });
  }

    setCropCoordinates = async (newCropPromise) => {
      this.setState({ crop: await newCropPromise });
    }

    toggle() {

      this.setState(prevState => ({
        modal: !prevState.modal
      }));
      if (this.props.crop && this.state.crop.unit == null) {
        this.setCrop(this.props.crop);
      }

      if (this.srcBlob !== 'data:image/jpeg;base64,' + this.props.src) {
        this.srcBlob = 'data:image/jpeg;base64,' + this.props.src;
      }

    }

    save() {
      console.log("ERROR: PhotoEditModel.save(): Not implemented.");
      console.log(this.state);
      let imageElement = document.querySelector('#PhotoEditModal .ReactCrop__image');
      console.log(imageElement);
      let file = transformToCroppedImage(imageElement, this.state.crop, 'croppedImage.jpg');
      let cropString = JSON.stringify(this.state.crop);
      this.props.save(file, cropString);
      this.toggle();
    }

    setDisabled() {
      if (this.state.crop.width <= 0 && this.state.crop.height <= 0) {
        return true;
      }
      return false;
    }

    render() {
      return (
        <div>
          {/* eslint-disable-next-line }
                <a href="javascript:undefined(0);" type="button" className="btn profile-button btn-sm fw-7 mb-2 mt-2" onClick={this.toggle}>{this.props.buttonLabel}</a>
          <Modal id='PhotoEditModal' isOpen={this.state.modal} toggle={this.toggle} centered={true} className={this.props.className}>
            <ModalHeader toggle={this.toggle}>Please crop your photo to be used on your ID card.</ModalHeader>
            <PhotoEdit src={this.srcBlob} setCrop={this.setCrop} crop={this.state.crop} />
            <ModalFooter>
              <Button class="btn profile-button btn-sm fw-7 mb-4 mt-4" onClick={this.save} disabled={this.setDisabled()}>Save crop</Button>{' '}
              <Button class="btn profile-button  btn-sm fw-7 mb-4 mt-4" onClick={this.toggle}>Cancel</Button>
            </ModalFooter>
          </Modal>
        </div>
      );
    }
}
*/

export class ProfilePage extends PureComponent {
  constructor(props) {
    super(props)

    this.state = {
      subscriberInfo: false,
      subscriberPK: false,
      idCardList: false,
      profileImage: false,
      employer: false,
      paperlessOption: false,
      file: false,
      fileId: false,
      uploaded: false,
      index: false,
      canRequestEdit: false,
      cropCoords: '',
    }
    this.handlePaperlessChange = this.handlePaperlessChange.bind(this)
    this.fileAdded = this.fileAdded.bind(this)
    this.onUploadComplete = this.onUploadComplete.bind(this)
    this.toggleImageCrop = this.toggleImageCrop.bind(this)
    this.subscription = new Subscription()

    this.cropPictureElement = React.createRef()
  }

  get subscriberInfo() {
    return this.state.subscriberInfo
  }
  get profileImage() {
    return this.state.profileImage
  }

  componentDidMount() {
    this.subscription.add(
      memberService
        .subscriberInfo()
        .pipe(
          switchMap((x) => {
            this.setState({
              subscriberInfo: x,
              subscriberPK: x.subscriberPK,
              patientPK: x.dependentPK,
              profileImage: x.image,
              paperlessOption: x.isPaperless,
              isSubmitting: false,
              isSuccessful: false,
              hasFailed: false,
              errorMessage: false,
              clearNotification: false,
              imageUploadStatus: false,
              employer: x.employerName,
              canRequestEdit: true,
            })
            return memberService.fetchCroppedCoordinates(x.dependentPK)
          })
        )
        .subscribe((response) => {
          var cropCoords = JSON.parse(response.data.result)
          this.setState({ cropCoords })
          this.forceUpdate()
        })
    )

    console.log(this.state)
  }

  componentWillUnmount() {
    this.subscription.unsubscribe()
    clearTimeout(this.timeoutID)
  }

  handlePaperlessChange = async (option) => {
    await this.setState({
      paperlessOption: option,
    })
    this.forceUpdate()
  }

  updateFields = async (isProfileImageUpdate) => {
    await this.subscription.add(
      memberService.fetchSubscriberInfo(this.state.subscriberPK).subscribe((x) => {
        console.log(x)
        this.setState(
          {
            subscriberInfo: x.data.result,
            subscriberPK: x.data.result.subscriberPK,
            patientPK: x.data.result.dependentPK,
            profileImage: x.data.result.image,
            paperlessOption: x.data.result.isPaperless,
          }
          //this.toggleImageCrop(isProfileImageUpdate) //this is refering to image cropping, we want it after uploading
        )
        this.forceUpdate()
        console.log(this.state)
      })
    )
  }

  toggleImageCrop(isProfileImageUpdate) {
    if (isProfileImageUpdate) {
      this.cropPictureElement.current.setProfileImage(this.state.profileImage)
      this.timeoutID = setTimeout(() => {
        this.cropPictureElement.current.toggle()
      }, 500)
    }
  }

  submitPaperlessOption = async () => {
    await this.setState({ isSubmitting: true })

    this.subscription.add(
      memberService
        .submitPaperlessOption({ subscriberPK: this.state.subscriberPK, isPaperless: this.state.paperlessOption })
        .subscribe(
          (e) => {
            console.log(
              'Updating PaperlessOption for: ' + this.state.subscriberPK + ' with new value: ' + this.state.paperlessOption
            )
            console.log(e.data.isSuccessful)
            if (e.data.isSuccessful) {
              this.setState({
                isSubmitting: false,
                isSuccessful: true,
                hasFailed: true,
              })
              this.updateFields(false)
              this.timeoutID = setTimeout(() => {
                this.setState({
                  isSubmitting: false,
                  isSuccessful: false,
                  hasFailed: false,
                  clearNotification: true,
                })
              }, 5000)
            } else {
              this.setState({
                isSubmitting: false,
                isSuccessful: false,
                hasFailed: true,
              })
            }
          },
          (error) => {
            this.setState({
              isSubmitting: false,
              isSuccessful: false,
              hasFailed: true,
              errorMessage: error.response.data[0].errorMessage,
            })
          }
        )
    )
  }

  fileAdded(e) {
    console.log('saving image')
    console.log(e)
    this.setState({ file: e.target.files[0] })
    this.fileUpload(e.target.files[0])
  }

  fileUpload = async (file) => {
    await this.setState({ isImageSubmitting: true })
    this.subscription.add(
      memberService.submitProfileImage(file, this.state.subscriberPK, this.state.patientPK).subscribe((x) => {
        this.onUploadComplete(x, true)
      })
    )
  }

  fileUploadCropped = async (croppedFile, coords) => {
    await this.setState({ isImageSubmitting: true })
    let file = await croppedFile
    this.subscription.add(
      memberService.submitCroppedProfileImage(file, this.state.subscriberPK, this.state.patientPK, coords).subscribe((x) => {
        this.onUploadComplete(x, false)
      })
    )
  }

  onUploadComplete(response, needsCrop) {
    console.log(response)
    if (response.data.isSuccessful) {
      this.setState({
        fileId: response.data,
        uploaded: true,
        isImageSubmitting: false,
        isImageSuccessful: true,
        hasImageFailed: false,
      })
      this.updateFields(needsCrop)

      this.timeoutID = setTimeout(() => {
        // queue removal of notification
        this.setState({
          isImageSubmitting: false,
          isImageSuccessful: false,
          hasImageFailed: false,
          clearImageNotification: true,
        })
      }, 5000)
    } else {
      this.setState({
        isImageSubmitting: false,
        isImageSuccessful: false,
        hasImageFailed: true,
        errorMessage: response.data.error,
      })
    }
  }

  openFileChooser(event) {
    $('#customFile:hidden').trigger('click')
  }

  render() {
    /*
      let editPhotoEnabled = false;
      if (this.state.dependentPK) {
        editPhotoEnabled = true;
      }
      */
    if (this.subscriberInfo) {
      return (
        <AuthConsumer>
          {({ isSubscriber, checkCostEstimatorVisibility }) => {
            const canEdit = isSubscriber()
            return (
              <div className="card text-white bg-primary-light border-transparent m-4">
                <div id="profile-container" className="m-4 mt-6">
                  <div className="row justify-content-center m-4">
                    <h5 className="text-light fw-6 fs-30">Edit Your Profile</h5>
                    <br />
                  </div>
                  <div className="row m-4">
                    {/* Profile Image */}
                    <div className="col-md-3 text-center">
                      <Stack sx={{ height: '100%' }} direction="column" gap={1}>
                        <ProfileImage profileImage={this.state.profileImage} />
                        <input type="file" className="" id="customFile" onChange={this.fileAdded} hidden />
                        <button type="button" className="btn profile-button btn-sm fw-7 mt-2" onClick={this.openFileChooser}>
                          Change Photo
                        </button>
                        <br />
                        {/* <PhotoEditModal ref={this.cropPictureElement} id="photo-edit-modal" buttonLabel="Crop Photo" className="" src={this.state.profileImage} save={this.fileUploadCropped} crop={this.state.cropCoords} disabled={!editPhotoEnabled} croppedImage={this.state.croppedImage} />*/}
                        <div>
                          <SubmissionNotification
                            isSubmitting={this.state.isImageSubmitting}
                            isSuccessful={this.state.isImageSuccessful}
                            hasFailed={this.state.hasImageFailed}
                            clearNotification={this.state.clearImageNotification}
                          />
                        </div>
                        <Stack sx={{ flexGrow: 1, justifyContent: 'flex-end', paddingBottom: 1 }}>
                          <SwitchUser checkCostEstimatorVisibility={checkCostEstimatorVisibility} />
                        </Stack>
                      </Stack>
                    </div>
                    {/* Profile Content */}
                    {canEdit ? (
                      <div className="col-sm profile-content">
                        <div className="card-body bg-primary-dark extra-rounded m-2">
                          <h6 className="card-section-header">
                            {FormatCapitalizedText(this.subscriberInfo.firstName)}{' '}
                            {FormatCapitalizedText(this.subscriberInfo.lastName)}
                          </h6>
                          <p>
                            <small className="fw-5 fs-14 text-light">{this.state.employer}</small>
                          </p>
                        </div>

                        <EditMemberComponent
                          canEdit={this.state.canRequestEdit}
                          address={FormatCapitalizedTextInObject(this.subscriberInfo.address)}
                          patientPK={this.state.patientPK}
                          subscriberPK={this.state.subscriberPK}
                          memberInfo={this.state.subscriberInfo}
                        />

                        {/* Paperless Inputs */}
                        <Row className="card-body bg-primary-dark extra-rounded m-2">
                          <h6 className="card-section-header">Paper Statement Preferences</h6>

                          <Col>
                            <div className="form-check mt-4">
                              <label className="form-check-label">
                                <Input
                                  name="paperless"
                                  type="radio"
                                  className="form-check-input"
                                  onChange={() => this.handlePaperlessChange(true)}
                                  defaultChecked={this.state.paperlessOption}
                                />
                                <p className="mb-0">
                                  <small className="fw-7 text-secondary">
                                    Don’t cut down any more trees for me. I want to view my statements online.
                                  </small>
                                </p>
                              </label>
                            </div>

                            <div className="form-check">
                              <label className="form-check-label">
                                <Input
                                  name="paperless"
                                  type="radio"
                                  className="form-check-input"
                                  onChange={() => this.handlePaperlessChange(false)}
                                  defaultChecked={!this.state.paperlessOption}
                                />
                                <p>
                                  <small className="fw-7 text-secondary">Please continue to mail me paper statements.</small>
                                </p>
                              </label>
                            </div>
                            <button
                              type="button"
                              className="btn profile-button btn-sm fw-7 mb-4 mt-4"
                              onClick={this.submitPaperlessOption}
                            >
                              Update
                            </button>
                            <SubmissionNotification
                              isSubmitting={this.state.isSubmitting}
                              isSuccessful={this.state.isSuccessful}
                              hasFailed={this.state.hasFailed}
                              clearNotification={this.state.clearNotification}
                            />
                          </Col>
                        </Row>
                      </div>
                    ) : (
                      <span />
                    )}
                  </div>
                </div>
              </div>
            )
          }}
        </AuthConsumer>
      )
    } else {
      return <LoadingCard />
    }
  }
}
